/**
 * Markdown directive helpers for EnhancedMarkdown rendering system
 * These generate directive syntax that's processed by remark plugins
 */

// Reference directives
export const createRefStartDirective = (refId: string): string =>
  ` :ref-start{refId="${refId}"} `;
export const createRefEndDirective = (refId: string): string =>
  ` :ref-end{refId="${refId}"} `;
export const createRefGroupDirective = (refIds: string): string =>
  ` :ref-group{refIds="${refIds}"}`;
export const createLegacyRefDirective = (refId: string): string =>
  ` :legacy-ref{refId="${refId}"}`;

// Message directives
export const createErrorDirective = (message: string): string =>
  `\n\n:::error\n\n_${message}_\n\n::: `;
export const createWarningDirective = (message: string): string =>
  `\n\n:::warning\n\n_${message}_\n\n::: `;
export const createOutputLimitDirective = (message: string): string =>
  `\n\n:::output-limit\n\n_${message}_\n\n::: `;
